/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

@Injectable({ providedIn: 'root' })
export class VirtualMachineServiceStrService {
    get = this.i18nService.get;

    i18n = {
        // 确认
        confirmBtn: this.get('common.confirm_button'),
        // 取消
        cancelBtn: this.get('common.cancel_button'),
        // 关闭
        closeBtn: this.get('common.close_button'),
        // 操作
        actionBtn: this.get('common.operation_button'),
        // 创建
        create: this.get('common.create_button'),
        // 打开控制台
        openConsole: this.get('system.vm_app_openConsole_btn'),
        // 删除
        delete: this.get('common.delete_button'),
        // 选择镜像
        selectImage: this.get('system.vm_app_task_selectImage_title'),
        // 描述
        descriptionTab: this.get('common.description_column'),
        // 运行状态
        runningstatus: this.get('system.runningStatus_column'),
        // CPU利用率
        cpuUsageTab: this.get('system.container_app_task_view_CPUUsage_col'),
        // 内存利用率
        memoryUsageTab: this.get('system.container_app_task_view_memoryUsage_col'),
        // 基础信息
        basicInfo: this.get('common.basicInfo_title'),
        // 请选择一个对象
        chooseOne: this.get('common.selectOnlyOneObject_lab'),
        // 当前未启用虚拟机服务
        notDeployedInfo1: this.get('system.container_networkPlane_task_notActivated_info1'),
        // 立即启用
        notDeployedInfoBtn: this.get('system.container_networkPlane_task_notActivated_here_btn'),
        // 或后续前往“设置 > 虚拟机设置”页面启用。
        notDeployedInfo2: this.get('system.container_networkPlane_task_notActivated_info2'),
        // 虚拟机名称
        vmName: this.get('system.vm_app_task_vmName_lab'),
        // 创建虚拟机
        createVirtualMachineCmdLab: this.get('system.vm_app_task_create_title'),
        // 删除虚拟机
        deleteVirtualMachineCmdLab: this.get('common.delete_title_wintitle', [this.get('system.vm_app_task_title')]),
        // 系统盘容量
        systemDiskSizeLab: this.get('system.vm_app_task_diskCapacity_lab'),
        // 创建时间
        createTime: this.get('system.vm_app_task_createTime_column'),
        // 更新时间
        updateTime: this.get('system.vm_app_task_updateTime_column'),
        // 所在节点
        ownedNode: this.get('system.vm_app_task_runningStatus_column'),
        // 删除高危提示
        deleteVirtualMachineDangerContent: this.get('system.VM_task_delete_confirm_msg'),
        // 容量提示
        capHelpTip: this.get('common.capacity_normalstatu_msg'),
        // 大于或等于最小容量提示
        minCapacityErr: this.get('system.vm_app_task_diskCapacityMini_valid', [10]),
        // 小于或等于最大容量提示
        maxCapacityErr: this.get('system.vm_app_task_diskCapacityMax_valid', [1000]),
        // 虚拟机名称校验提示
        nameValidMsg: this.get('system.vm_app_task_vmAlias_valid'),
        // 空提示
        nullErrMsg: (name: string): string => this.get('common.null_validation', [name]),
        // 长度提示
        lengthErrMsg: (min: number, max: number): string => this.get('common.length_msg', [min, max]),
        // 虚拟机连接异常
        connectionAbnormalLab: this.get('system.vm_app_openConsole_conAbnormal_msg'),
        // 虚拟机断开提示
        reLoginTip: this.get('system.vm_app_openConsole_reLogin_msg'),
        // 浏览器不支持
        browserNotSupportLab: this.get('system.vm_app_openConsole_broTips_msg'),
        // 推荐浏览器提示
        recommendedBrowserTip: this.get('system.vm_app_openConsole_broDetails_msg'),
        // Send Ctrl+Alt+Del
        sendCtrlAltDelLab: this.get('system.vm_app_openConsole_sendcal_btn'),
        // 前端网络平面
        frontendNetworkPlaneLab: this.get('system.vm_app_front_networkPlane_value_upper'),
        // 选择前端网络平面
        selectFrontendNetworkPlaneTitle: this.get('system.vm_app_front_networkPlane_sle_value'),
        // 后端网络平面
        backendNetPlaneLab: this.get('system.vm_app_back_networkPlane_value_upper'),
        // 选择后端网络平面
        selectBackendNetPlaneTitle: this.get('system.vm_app_back_networkPlane_sle_value'),
        // 名称
        nameLab: this.get('common.name_column'),
        // ID
        id: this.i18nService.get('common.ID_column'),
        // 服务端口
        serverPortLab: this.get('system.vm_app_task_serverPort_column'),
    };

    // 特殊处理的key
    neededKey = {
        status: 'status',
        running: 'Running',
    };

    /**
     * 运行状态
     */
    appRunningStatus = {
        Pending: this.get('common.creating_lab'),
        Running: this.get('system.container_app_task_status_running_value'),
        Rebooting: this.get('system.vm_app_task_vmStatus_rebooting_value'),
        Poweroff: this.get('system.vm_app_task_vmStatus_powerOff_value'),
        Deleted: this.get('system.vm_app_task_vmStatus_deleted_value'),
    };

    constructor(
        private i18nService: I18nService,
    ) { }
}
